// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"1e4bbcc74974edcf","5285":"08048b03916c6b6f"}[chunkId] + ".css";
};